import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_288: DocMigration = {
  maxSchemaVersion: "0.0.288",
  description: "Convert foundation assembly overrides to array",
  apply(json: any): any {
    const staticRoomLayouts = json.staticRoomLayouts;
    for (const layoutKey in staticRoomLayouts) {
      const layout = staticRoomLayouts[layoutKey];
      const foundationAssemblies = layout.foundationAssemblies;
      if (!foundationAssemblies) {
        continue;
      }
      for (const foundationAssembly of foundationAssemblies) {
        const foundationAssemblyOverride = foundationAssembly.foundationAssemblyOverride;
        if (!foundationAssemblyOverride) {
          continue;
        }
        const overrideArray: any[] = [];
        for (const foundationHash in foundationAssemblyOverride) {
          const override = foundationAssemblyOverride[foundationHash];
          overrideArray.push({
            ...override,
            id: uid(),
            name: foundationHash,
            superSystem: foundationHash.split(".")[0],
          });
        }
        delete foundationAssembly.foundationAssemblyOverride;
        foundationAssembly.foundationAssemblyOverrides = overrideArray;
      }
    }
    return json;
  },
};

export default migration_0_0_288;
